import { Box, Button, Flex, Img, Link, Stack, useBreakpointValue } from '@chakra-ui/react'
import MedleveHeroMobile from 'components/sections/MedleveHeroMobile'
import ArrowRightOmens from 'components/svg/ArrowRightOmens'
import { Body1, H2, H3, SuperTitle } from 'components/typography'
import { ONBOARDING_INITIAL_STEP } from 'constants/onboarding'
import { HERO_SECTION_ID } from 'layouts/LadingLayout/components/Navbar/components/NavbarDesktop'
import { useRouter } from 'next/router'
import { FC } from 'react'

const MedleveHeroSection: FC = () => {
  const isMobile = useBreakpointValue({ base: true, lg: false })
  const { pathname } = useRouter()
  const gads = pathname.includes('gads')

  if (isMobile) {
    return (
      <Stack id={HERO_SECTION_ID} w="full" spacing="none" pos="relative" align="stretch">
        <MedleveHeroMobile gads={gads} />
      </Stack>
    )
  }

  return (
    <Stack
      id={HERO_SECTION_ID}
      height="100vh"
      minH={{ base: 'none', lg: '810px' }}
      w="full"
      spacing="none"
      pos="relative"
      justify="flex-end"
      align={'center'}
    >
      <Box height="full" width="full" pos="absolute" zIndex="-1000">
        <Img
          src="/landings/doctor-using-smarphone.webp"
          alt="man eating"
          objectPosition={'40%'}
          pos="absolute"
          top={0}
          left={0}
          w="full"
          h="full"
          objectFit="cover"
        />
      </Box>
      <Box height="full" width="full" bg="black" opacity="0.4" pos="absolute" zIndex="-1000" />
      <Flex position={'absolute'} top={{ base: '85px', lg: '100px' }} right={{ base: '24px', lg: '48px' }}>
        <Img src="/landings/Anvisa.png" alt="Anvisa" w="full" h={{ base: '50px', lg: '100px' }} />
        <Img src="/landings/SSL.png" alt="SSL" w="full" h={{ base: '50px', lg: '100px' }} />
        <Img src="/landings/LGPD.png" alt="LGPD" w="full" h={{ base: '50px', lg: '100px' }} />
      </Flex>
      <Flex
        direction={'row'}
        w={'full'}
        maxW={'1600px'}
        justify={'space-between'}
        align={'flex-end'}
        pb={12}
        px={{ base: '24px', lg: '48px' }}
      >
        <Flex maxW={'650px'} direction={'column'} gap={{ base: 0, lg: 10 }} color={'alabaster'}>
          {gads ? (
            <SuperTitle pt="48px" fontSize="3.25rem" lineHeight="60px">
              Comece seu tratamento <br />
              com acompanhamento <br />
              médico online
            </SuperTitle>
          ) : (
            <SuperTitle pt="48px" fontSize="3.25rem" lineHeight="60px">
              Obtenha sua prescrição* <br />
              agora e compre sua caneta <br />
              de emagrecimento
            </SuperTitle>
          )}

          <H2
            mb={4}
            fontWeight={800}
            fontSize={{ base: '1rem', lg: '1.5rem' }}
            letterSpacing={{ base: '-0.01em', lg: '-0.03em' }}
            lineHeight={{ base: '1.25rem', lg: '1.75rem' }}
          >
            <Box as="span" color={'#99b9e9'}>
              Perder peso custa menos do que você imagina!
            </Box>{' '}
            {gads
              ? ' Receba orientação médica especializada e descubra o tratamento ideal para você, com segurança e praticidade.'
              : 'Conte com orientação médica especializada para iniciar seu tratamento com segurança e receba os medicamentos na sua casa.'}
          </H2>
          <Link href={`/onboarding/weight_loss/${ONBOARDING_INITIAL_STEP}`}>
            <Button
              h={'full'}
              maxH={'max-content'}
              w={{ base: '224px', lg: '304px' }}
              px={{ base: '28px', lg: '32px' }}
              py={{ base: '28px', lg: '40px' }}
              borderRadius={{ base: '24px', lg: '32px' }}
              bg={'medleve'}
              color={'alabaster'}
              _hover={{ bg: '#30496b' }}
            >
              <Flex w={'full'} justify={'space-between'} align={'center'}>
                <Body1
                  fontWeight={800}
                  fontSize={{ base: '1rem', lg: '1.5rem' }}
                  sx={{ fontFeatureSettings: "'ss01' on, 'liga' off, 'calt' off" }}
                  letterSpacing={{ base: '-0.01em', lg: '-0.03em' }}
                  lineHeight={{ base: '1.25rem', lg: '1.75rem' }}
                >
                  Começar
                </Body1>
                <ArrowRightOmens fill="alabaster" boxSize={{ base: '14px', lg: '18px' }} />
              </Flex>
            </Button>
          </Link>
        </Flex>
        <Flex direction={'column'} gap={4} maxW={'400px'}>
          <Flex
            bg={'rgba(31, 30, 30, 0.4)'}
            backdropFilter={'blur(20px)'}
            shadow="none"
            color="alabaster"
            width="auto"
            borderRadius={{ base: '18px', lg: '24px' }}
            h={'max-content'}
            p={4}
          >
            <H3
              fontWeight={400}
              fontSize={{ base: '1rem', lg: '1.5rem' }}
              letterSpacing={{ base: '-0.01em', lg: '-0.03em' }}
              lineHeight={{ base: '1.25rem', lg: '1.75rem' }}
            >
              {gads ? 'Consulta sem agendamento' : 'Acompanhamento médico 100% online'}
            </H3>
          </Flex>
          <Flex
            bg={'rgba(31, 30, 30, 0.4)'}
            backdropFilter={'blur(20px)'}
            shadow="none"
            color="alabaster"
            width="auto"
            borderRadius={{ base: '18px', lg: '24px' }}
            h={'max-content'}
            p={4}
          >
            <H3
              fontWeight={400}
              fontSize={{ base: '1rem', lg: '1.5rem' }}
              letterSpacing={{ base: '-0.01em', lg: '-0.03em' }}
              lineHeight={{ base: '1.25rem', lg: '1.75rem' }}
            >
              {gads ? 'Atendimento 100% online' : 'Compre sua caneta online ou na farmácia de sua escolha'}
            </H3>
          </Flex>
          <Flex
            bg={'rgba(31, 30, 30, 0.4)'}
            backdropFilter={'blur(20px)'}
            shadow="none"
            color="alabaster"
            width="auto"
            borderRadius={{ base: '18px', lg: '24px' }}
            h={'max-content'}
            p={4}
          >
            <H3
              fontWeight={400}
              fontSize={{ base: '1rem', lg: '1.5rem' }}
              letterSpacing={{ base: '-0.01em', lg: '-0.03em' }}
              lineHeight={{ base: '1.25rem', lg: '1.75rem' }}
            >
              {gads ? 'Melhores especialistas do Brasil' : 'Receba sua recomendação digitalmente'}
            </H3>
          </Flex>
          {!gads && (
            <Flex
              bg={'rgba(31, 30, 30, 0.4)'}
              backdropFilter={'blur(20px)'}
              shadow="none"
              color="alabaster"
              width="auto"
              borderRadius={{ base: '18px', lg: '24px' }}
              h={'max-content'}
              p={4}
            >
              <H3
                fontWeight={400}
                fontSize={{ base: '1rem', lg: '1.5rem' }}
                letterSpacing={{ base: '-0.01em', lg: '-0.03em' }}
                lineHeight={{ base: '1.25rem', lg: '1.75rem' }}
              >
                Baixe sua receita assinada digitalmente
              </H3>
            </Flex>
          )}
        </Flex>
      </Flex>
    </Stack>
  )
}

export default MedleveHeroSection
